import React from "react";
import { Box, TextField, TextFieldProps } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";

interface SettingsFormFieldProps {
  label: string;
  readOnly?: boolean;
  children?: React.ReactNode;
  textFieldProps?: TextFieldProps;
}

const SettingsFormField: React.FC<SettingsFormFieldProps> = ({
  label,
  readOnly = false,
  children,
  textFieldProps,
}) => {
  const labelSx = {
    fontSize: "11px",
    fontWeight: 700,
    textTransform: "uppercase" as const,
    letterSpacing: "1.2px",
    color: dt.textSecondary,
    fontFamily: dt.font,
    mb: "6px",
  };

  const readOnlyInputSx = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#F9FAFB",
      borderRadius: dt.radiusSm,
      fontFamily: dt.font,
      fontSize: "14px",
      color: dt.textMuted,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E5E7EB",
      },
    },
  };

  const editableInputSx = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: dt.inputBg,
      borderRadius: dt.radiusSm,
      fontFamily: dt.font,
      fontSize: "14px",
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: dt.blue,
        boxShadow: `0 0 0 3px ${dt.blueGlow}`,
      },
    },
    "& .MuiFormHelperText-root": {
      fontFamily: dt.font,
      fontSize: "11px",
    },
  };

  const inputSx = readOnly ? readOnlyInputSx : editableInputSx;

  return (
    <Box>
      <Box sx={labelSx}>{label}</Box>
      {children ? (
        children
      ) : (
        <TextField
          fullWidth
          disabled={readOnly}
          sx={inputSx}
          size="small"
          {...textFieldProps}
        />
      )}
    </Box>
  );
};

export default SettingsFormField;
